module.exports = __webpack_public_path__ + "img/gb9113_21.prt.f0afb623.jpg";